/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PagePosition } from './pagePosition';

export interface UssdCampaignPageModel { 
    id?: string;
    serviceProviderId?: string;
    ussdCampaignId?: string;
    pageName?: string;
    shortCode?: string;
    shortCodeKeyNumber?: string;
    status?: boolean;
    position?: PagePosition;
    dateCreated?: Date;
    dateModified?: Date;
    isConfigured?: boolean;
}